/**
 * Front-end download helper (Phase 5-5).
 *
 * 只负责触发浏览器下载 —— 真正的水印（隐藏列 + 文件名 hash + L4/L5 拒绝）由
 * admin-service `services/export/watermark.service.ts` 在 CSV 生成阶段就做好；
 * 前端不重复实现，避免双源真相。
 */

export function triggerDownload(blob: Blob, filename: string): void {
  if (typeof URL === 'undefined' || typeof URL.createObjectURL !== 'function') {
    // SSR / 测试环境（部分 jsdom）—— 退化为 no-op，调用方应通过 try/catch 判断
    return;
  }
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  // 不挂 DOM 也能触发 click，但 Safari 需要 element 在 DOM 里
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
